import React from "react";
const AppContainerContext = React.createContext(null);
export default AppContainerContext;
